export const CELL_CANNOT_BE_EVALUATED = "Cell cannot be evaluated"
